import React, { ReactElement, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RiAlertFill } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import Modal from '../../../components/modal/modal';
import FormErrorLabel from '../../../components/form/formErrorLabel';
import LoadingSpinner from '../../../components/spinner/loadingSpinner';
import { useBuildingServiceRemoveAreaFromBuildingMutation } from '../../../api/gen/buildings';

interface RemoveAreaFromBuildingModalProps {
  isOpen: boolean;
  buildingId: string;
  groupId: string;
  areaId: string;
  description: string;
  closeHandler: () => void;
}

function RemoveAreaFromBuildingModal({
  isOpen,
  buildingId,
  groupId,
  areaId,
  description,
  closeHandler
}: RemoveAreaFromBuildingModalProps): ReactElement {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [removeArea, { isSuccess, isError, isLoading, reset }] =
    useBuildingServiceRemoveAreaFromBuildingMutation();

  useEffect(() => {
    if (isSuccess) {
      reset();
      closeHandler();
    }
  }, [isSuccess, reset, navigate, closeHandler]);

  const close = (): void => {
    closeHandler();
    reset();
  };

  return (
    <Modal
      isOpen={isOpen}
      closeHandler={() => {
        close();
      }}
      title="Bereich löschen"
    >
      <div className="flex flex-col w-full">
        <div className="w-full flex flex-col">
          {isError ? (
            <FormErrorLabel
              className="mb-3"
              icon={<RiAlertFill size={20} />}
              label={t('modals.deleteArea.error')}
            />
          ) : null}
        </div>
        <h2 className="mb-4 font-bold">Bereichsbezeichnung: {description}</h2>
        <p>{t('modals.deleteArea.disclaimer')}</p>
        <div className="flex items-end flex-col w-full mt-5">
          {!isLoading && buildingId != null && groupId != null ? (
            <button
              className=" rounded-lg shadow-md w-32 h-10 bg-red-500 text-white"
              type="button"
              onClick={() => removeArea({ buildingId, groupId, areaId })}
            >
              {t('modals.deleteArea.delete')}
            </button>
          ) : (
            <div className="rounded-lg shadow-md w-24  h-10  p-4 bg-red-500 text-white flex justify-center items-center">
              <LoadingSpinner />
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
}

export default RemoveAreaFromBuildingModal;
